import React from "react";
import inventoryImage from "../../../assets/service-inventory.png";
import financialImage from "../../../assets/service-financial.png";
import supplyChainImage from "../../../assets/service-supplychain.png";
import crmImage from "../../../assets/service-crm.png";
import hrImage from "../../../assets/service-hr.png";

const Modules = () => {
  return (
    <div className="erp-integration-modules-wrapper">
      <h1>ERP Modules We Integrate</h1>
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card">
            <div className="title">
              <p>
                Inventory
                <br /> Management
              </p>
            </div>
            <div className="image-container">
              <img src={inventoryImage} alt="inventory" />
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card">
            <div className="title">
              <p>
                Financial
                <br /> Management
              </p>
            </div>
            <div className="image-container">
              <img src={financialImage} alt="financial" />
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card">
            <div className="title">
              <p>
                Supply Chain
                <br /> Management
              </p>
            </div>
            <div className="image-container">
              <img src={supplyChainImage} alt="supply-chain" />
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card">
            <div className="title">
              <p>
                Customer Relationship
                <br /> Management
              </p>
            </div>
            <div className="image-container">
              <img src={crmImage} alt="crm" />
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card">
            <div className="title">
              <p>
                Human Resources
                <br /> Management
              </p>
            </div>
            <div className="image-container">
              <img src={hrImage} alt="hrm" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modules;
